<template>
  <div class="schoolIntroduction-page">
    <!-- 横屏 -->
    <div class="cross" v-if="screenType == 0">
      <!-- 图文和纯文字 -->
      <div
        class="crossInner"
        v-if="dataInfor.showTypeValue == 1 || dataInfor.showTypeValue == 2"
      >
        <div class="title">{{ dataInfor.title }}</div>
        <div class="page-content">
          <div class="page-leftcontent" v-if="dataInfor.showTypeValue == 1">
            <div class="swiper-containerFocus">
              <div class="swiper-wrapper">
                <div
                  class="swiper-slide"
                  v-for="(item, index) in dataInfor.picture"
                  :key="index"
                >
                  <img :src="'/dsf5' + item.path" class="swiper-img" />
                </div>
              </div>
              <div class="swiper-pagination"></div>
            </div>
          </div>
          <div
            class="page-rightcontent"
            :style="{
              paddingLeft:
                (dataInfor.showTypeValue == 2 ? '0' : '0.15') + 'rem',
            }"
            v-html="dataInfor.content"
          ></div>
        </div>
      </div>
      <!-- 大图 -->
      <div
        class="crossBigschoolIntroduction"
        v-if="dataInfor.showTypeValue == 4"
      >
        <div class="swiper-containerFocus">
          <div class="swiper-wrapper">
            <div
              class="swiper-slide"
              v-for="(item, index) in dataInfor.picture"
              :key="index"
            >
              <img :src="'/dsf5' + item.path" class="swiper-img" />
            </div>
          </div>
          <div class="swiper-pagination"></div>
        </div>
      </div>
      <!-- 视频 -->
      <videoSchoolIntroduction :screenType="screenType" :data="dataInfor" v-if="dataInfor.showTypeValue == 3"></videoSchoolIntroduction>
    </div>
    <!-- 竖屏 -->
    <div v-else class="vertical">
      <!-- 图文和纯文字 -->
      <div
        class="vertical-content"
        v-if="dataInfor.showTypeValue == 1 || dataInfor.showTypeValue == 2"
      >
        <div class="title" v-if="dataInfor.showTypeValue == 2">
          {{ dataInfor.title }}
        </div>
        <div class="swiper-containerFocus" v-if="dataInfor.showTypeValue == 1">
          <div class="swiper-wrapper">
            <div
              class="swiper-slide"
              v-for="(item, index) in dataInfor.picture"
              :key="index"
            >
              <img :src="'/dsf5' + item.path" class="swiper-img" />
            </div>
          </div>
          <div class="swiper-pagination"></div>
        </div>
        <div
          class="vertical-detail"
          :style="{
            marginTop: (dataInfor.showTypeValue == 2 ? '0.21' : '0.15') + 'rem',
          }"
          v-html="dataInfor.content"
        ></div>
      </div>
      <!-- 大图 -->
      <div
        class="verticalBigschoolIntroduction"
        v-if="dataInfor.showTypeValue == 4"
      >
        <div class="swiper-containerFocus">
          <div class="swiper-wrapper">
            <div
              class="swiper-slide"
              v-for="(item, index) in dataInfor.picture"
              :key="index"
            >
              <img :src="'/dsf5' + item.path" class="swiper-img" />
            </div>
          </div>
          <div class="swiper-pagination"></div>
        </div>
      </div>
      <!-- 视频 -->
      <videoSchoolIntroduction :screenType="screenType" :data="dataInfor" v-if="dataInfor.showTypeValue == 3"></videoSchoolIntroduction>
    </div>
  </div>
</template>

<script>
import videoSchoolIntroduction from "./videoSchoolIntroduction.vue"
export default {
  name: "schoolIntroduction",
  components: {
    videoSchoolIntroduction
  },
  data() {
    return {
      screenType: 0, //屏幕类型：0为横向，1为纵向
      dataInfor: {}, // 数据
    };
  },
  created() {
    this.loadScript(() => {
      this.$nextTick(() => {
        this.initSwiper();
      });
    });
    this.screenType = this.$route.meta.screenType;
  },
  mounted() {
    this.getData();
  },
  methods: {
    //图文和视频信息，页面详情
    getData() {
      var equipmentTypeValue = 1;
      if (this.screenType == 1) {
        equipmentTypeValue = 2
      }
      var params = {
        equipmentTypeValue: equipmentTypeValue, // 屏幕类型
        releaseTypeValue: "1",
      };
      this.$http.get("/teas/screen/getInformation", params).done((res) => {
        if (res.success) {
          this.dataInfor = res.data[0];
          this.$nextTick(() => {
            this.initSwiper();
          });
        } else {
          dsf.layer.message(data.message, false);
        }
      });

      // }
      // });
    },
    // 初始化swiper
    async initSwiper() {
      const _this = this;
      this.$nextTick(() => {
        this.mySwiper = new Swiper(".swiper-containerFocus", {
          autoplay: true,
          pagination: {
            el: ".swiper-pagination",
          },
          on: {},
        });
      });
    },
    // 加载js
    loadScript(callback) {
      this.$http
        .importFiles([
          dsf.url.getWebPath("$/js/libs/swiper/swiper-bundle.min.css"),
          dsf.url.getWebPath("$/js/libs/swiper/swiper-bundle.min.js"),
        ])
        .then(() => {
          callback?.();
        })
        .catch(() => {
          dsf.layer.message("加载fabric文件报错", false);
          reject();
        });
    },
  },
};
</script>

<style>
</style>